import React, {memo} from 'react';
import styled from 'styled-components';
import {Title1} from '../../../../components/Typography';
import CategoriesBar from './components/CategoriesBar';
import Category from './components/Category';
import MenuRewardsContainer from '../../../MenuRewards/MenuRewardsContainer';
import appConfig from '../../../../../app-config';
import OrderStatusContainer from '../../../OrderStatus/OrderStatusContainer';
import CartMenuSidebarContainer from '../../../CartMenuSidebar/CartMenuSidebarContainer';
import MenuSearch from '../../../ParentChild/Menu/MenuSearch';
import GlobalSearchContainer from '../GlobalSearchMenu/GlobalSearchContainer';
import {connectSearchBox} from 'react-instantsearch-dom';

const ProductCartWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 264px;
  grid-gap: 32px;
  margin: 0 5%;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 786px) {
    margin-top: -50px;
    display: block;
    margin-top: 12px;
  }
`;

const RewardWrapper = styled.div``;

const RewardTitleWrapper = styled(Title1)`

  // text-transform: ${props => props.theme.rewardTitleTextTransform};
  letter-spacing: 0.04px;
  margin-top: 32px;
  font-weight: 600;
  // width: max-content;
  width: fit-content;

  :after {
    content: '';
    display: block;
    width: calc(100% + 2px);
    padding-top: 2px;
    border-bottom: ${props => props.categoriesBarSelectedBorderColorWidth} solid
      ${props =>
        appConfig.styleConfig.separatorColor
          ? appConfig.styleConfig.separatorColor
          : props.theme.primaryColor};
  }
`;

const Menu = ({
  categories,
  products,
  combos,
  handleProductPreviewClick,
  handleComboPreviewClick,
  dontSelectMyOrders,
  orderSettingReducer,
  searchProduct,
  currentRefinement,
  refine,
}) => {
  const selectProduct = productId =>
    products.find(product => product.product_id === productId);

  const filteredCategory = categories.filter(
    category =>
      (category.products.length == 1 &&
        selectProduct(category.products[0].product_id)) ||
      category.products.length > 1 ||
      category.sub_categories ||
      category.category_id === 998 ||
      category.name === 'My Orders'
  );

  return (
    <div>
      {appConfig.isParentChildClient ? (
        <MenuSearch
          currentLocation={orderSettingReducer}
          searchProduct={searchProduct}
        />
      ) : null}
      {currentRefinement &&
      currentRefinement !== '' &&
      appConfig.isGlobalSearchEnabled ? (
        <GlobalSearchContainer
          refine={refine}
          handleComboPreviewClick={handleComboPreviewClick}
        />
      ) : (
        <div>
          <CategoriesBar
            id="Menu-CategoriesBar"
            categories={filteredCategory}
            dontSelectMyOrders={dontSelectMyOrders}
          />

          <ProductCartWrapper>
            <div>
              {appConfig.isOrderStatusEnabled && <OrderStatusContainer />}
              {(!appConfig.isLoyaltyEnabled && !appConfig.isOffersEnabled) ||
              appConfig.appSource === 'opa' ? null : (
                <RewardWrapper>
                  <RewardTitleWrapper>
                    <span id="MenuB-AppTitle">{appConfig.appTitle}</span>
                    <span id="MenuB-Rewards" style={{marginLeft: '10px'}}>
                      {appConfig.appSource === 'iQ' ? 'LOYALTY' : 'Rewards'}
                    </span>
                  </RewardTitleWrapper>
                  <MenuRewardsContainer />
                </RewardWrapper>
              )}

              {categories.map(category => (
                <Category
                  id="MenuB-Category"
                  category={category}
                  products={products}
                  combos={combos}
                  handleComboPreviewClick={handleComboPreviewClick}
                  handleProductPreviewClick={handleProductPreviewClick}
                  key={category.category_id}
                />
              ))}
            </div>

            <CartMenuSidebarContainer />
          </ProductCartWrapper>
        </div>
      )}
    </div>
  );
};

export default appConfig.isGlobalSearchEnabled
  ? memo(connectSearchBox(Menu))
  : memo(Menu);
